module.exports = __webpack_public_path__ + "media/18.8582a5f3.mp3";